import {animate, style, transition, trigger} from '@angular/animations';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  API,
  ComparisonOperator,
  CullAtomDTO, CullWithAtomsDTO,
  DeviceFullDTO, PlayerCullDTO,
  PlayerPathBasedStructureCullAtomDTO, ScreenFullDTO,
} from '../../../services/api/api';
import {ModalService} from '../../../services/gui/modal/modal.service';
import {Observable} from 'rxjs';
import {UtilService} from '../../../services/util.service';

@Component({
  selector: 'sb-filter-player-cull',
  templateUrl: './sb-filter-player-cull.component.html',
  styleUrls: ['./sb-filter-player-cull.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [style({ transform: 'translateX(-100%)' }), animate('200ms ease-in', style({ transform: 'translateX(0%)' }))]),
      transition(':leave', [animate('200ms ease-in', style({ transform: 'translateX(+100%)' }))]),
    ]),
  ],
  standalone: false,
})
export class SbFilterPlayerCullComponent implements OnInit {
  // tslint:disable-next-line:variable-name
  _cull: PlayerCullDTO;
  @Input() set cull(val: PlayerCullDTO) {
    this._cull = val as PlayerCullDTO;
  }

  get cull(): PlayerCullDTO {
    return this._cull;
  }

  @Input() easyMode: boolean;
  @Input() disabled: boolean;
  @Output() cullChange: EventEmitter<PlayerCullDTO> = new EventEmitter<PlayerCullDTO>();

  easyModeRows: EasyModeRow[];
  expression = '';
  loading = true;

  collapsed: boolean = false;
  selectedDevices: DeviceFullDTO[];
  inverted: boolean = false;

  constructor(
    private api: API,
    public modal: ModalService,
    public util: UtilService
  ) {
    this.selectedDevices = [];
    this.disabled = false;
    this.easyModeRows = [];
    this.expression = '';
    this.loading = true;
    this.inverted = false;
  }

  ngOnInit(): void {
    // TODO remove next line when easy mode for playercull is implemented
    this.easyMode = false;

    if (this.cull && this.cull?.staticElements) {
      this.inverted = this.cull.invertedStatic;
    } else {
      this.cull.staticElements = [];
      this.inverted = false;
    }

    // this.setupPlayerFields();
    if (this.cull.atoms && this.cull.atoms.length && this.easyMode) {
      const easyModeRowCounter = this.cull.atoms.length;

      const easyModeRows: EasyModeRow[] = [];

      for (let i = 0; i < easyModeRowCounter; i++) {
        let value: PlayerPathBasedStructureCullAtomDTO;
        const r: EasyModeRow = new EasyModeRow();
        value = this.cull.atoms[i] as PlayerPathBasedStructureCullAtomDTO;
        r.field = value.field;
        r.value = value.values[0];
        easyModeRows.push(r);
      }
      this.easyModeRows = easyModeRows;
    } else if (this.easyMode) {
      this.easyModeRows = [new EasyModeRow()];
    }
    if (!this.cull.staticElements || this.cull.staticElements.length === 0) {
      this.collapsed = true;
    }
  }

  /*
  private setupPlayerFields() {
    this.api.ca_md_DeviceAttribute_retrieveAllDatatypes().subscribe((data: DeviceAttributeDatatypeDTO[]) => {
      data.forEach((r, i) => {
        this.fieldValues.push({id: r.id, name: r.name});
      });
      this.loading = false;
    }, error => {
      this.errorHandler.errorHandler(error);
    });
  }
   */

  addRow() {
    const row = new EasyModeRow();
    this.easyModeRows.push(row);
    this.updateDTO();
  }

  removeRow(index) {
    this.easyModeRows.splice(index, 1);
    this.updateDTO();
  }

  rowChanged(r: EasyModeRow) {
    this.updateDTO();
  }

  emitChange(cull?: PlayerCullDTO) {
    if (cull) {
      this.cull.atoms = cull.atoms;
    }
    this.cullChange.emit(this.cull);
  }

  updateDTO() {
    /* TODO when easymode is implemented
    const atoms: CullAtomDTO[] = [];
    let numCounter = 1;
    let expression = '';
    let i = 0;
    // debugger;
    for (const r of this.easyModeRows) {
      const rowAtoms = this.rowToAtomDTOs(r);
      if (rowAtoms && rowAtoms.length) {
        if (i !== 0) {
          expression += '|';
        }

        let k = 0;
        let rowExpression = '';

        for (const a of rowAtoms) {
          a.id = {num: numCounter++};
          rowExpression += a.id.num;
          k++;
        }

        expression += rowExpression;

        for (const a of rowAtoms) {
          atoms.push(a);
        }
      }
      i++;
    }
     */

    this.collapsed = this.cull.staticElements.length <= 0;
    // this.cull.atoms = atoms;
    // this.cull.expression = expression;
    this.cull.invertedStatic = this.inverted;
    this.emitChange();
  }

  resolveStaticElements(): Promise<ScreenFullDTO[]> {
    return new Promise<ScreenFullDTO[]>(res => {
      let obs: Observable<CullWithAtomsDTO>;
      if (this.cull.id) {
        obs = this.api.cs_Cull_updatePlayerCullPreview(this.cull as PlayerCullDTO);
      } else {
        if (this.cull.company) {
          obs = this.api.cs_Cull_createPlayerCullCompanyScopedPreview(this.cull.company.id, this.cull as PlayerCullDTO);
        } else {
          obs = this.api.cs_Cull_createPlayerCullClientScopedPreview(this.cull as PlayerCullDTO);
        }
      }
      if (obs) {
        obs.subscribe((cull: PlayerCullDTO) => {
          res(cull.staticElements);
        });
      } else {
        res([]);
      }
    });
  }

  rowToAtomDTOs(r: EasyModeRow): PlayerPathBasedStructureCullAtomDTO[] {
    if (!r.field || !r.value) {
      return null;
    }

    const ret: PlayerPathBasedStructureCullAtomDTO[] = [];

    const a: PlayerPathBasedStructureCullAtomDTO = new PlayerPathBasedStructureCullAtomDTO();
    a.type = 'PlayerByDeviceAttributeAtom';
    a.operator = ComparisonOperator.Equal;
    a.field = r.field;
    a.values = [r.value];

    ret.push(a);
    return ret;
  }

  toggleInverted() {
    this.inverted = !this.inverted;
    this.updateDTO();
  }

  addScreenRow() {
    this.modal
      .modal(
        {
          title: '',
          modalOptions: { windowClass: 'bigXL' },
        },
        {
          templateId: 'inventorySelectionModal',
        },
        { type: 'cullEdit' }
      )
      .then((screens: ScreenFullDTO[]) => {
        if (screens) {
          this.addScreen(screens);
        }
      })
      .catch(() => {});

    /*    this.modal.showNavigationModal({
          entryComponent: {
            value: InventoryWrapperComponent,
            data: {pauseNotifications: false, selectedDevices: this.selectedDevices ? this.selectedDevices : [] }
          },
          title: undefined,
          modalOptions: {
            windowClass: 'bigXL',
          }
        }).then((resultDevices: DeviceFullDTO[]) => {
          if (resultDevices && resultDevices.length > 0) {
            for (const singleDevice of resultDevices) {
              // this.selectedDevices.push(singleDevice);
              this.addScreen(singleDevice.screens);
            }
          }
        }).catch(() => {
        });*/
  }

  addScreen(screens: ScreenFullDTO[]) {
    const tempScreens: ScreenFullDTO[] = [];
    tempScreens.push(...this.cull.staticElements);
    const idArray = this.util.arrayToIdArray(this.cull.staticElements);
    if (screens && screens.length > 0) {
      if (this.cull && this.cull.staticElements.length > 0) {
        for (const screen of screens) {
          if (idArray.indexOf(screen.id) === -1) {
            tempScreens.push(screen);
          }
        }
      } else {
        tempScreens.push(...screens);
      }
    }
    this.cull.staticElements = tempScreens;
    this.resolveStaticElements().then((receivedScreens: ScreenFullDTO[]) => {
      this.cull.staticElements = receivedScreens;
      this.updateDTO();
    });
  }

  openDetails() {
    this.collapsed = !this.collapsed;
  }

  removeScreen(index: number) {
    this.cull.staticElements.splice(index, 1);
    this.updateDTO();
  }
}

class EasyModeRow {
  field: string;
  value: string;
}
